import React from 'react';
import ReactDOM from 'react-dom/client';
// Composants
import App from './App';
import ErrorBoundary from './components/Utils/ErrorBoundary';
// Redux
import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers';
import { setIsOnline, setUpdateAvailable } from './actionCreators/appActions';
// Librairies
import Axios from 'axios';
// Semantic UI
import 'semantic-ui-css/semantic.min.css';
// Styles
import './styles/index.css';
// Utils
import { onUpdateAvailable } from './serviceWorker';
import Connectivity, { installConnectivity } from './utils/offline/Connectivity';
import RealtimeUtil from './utils/RealtimeUtil';

//? Importé par index.js une fois la langue chargée. Garder l'ordre des imports : il fixe l'ordre des feuilles de style
//? (les styles des composants d'App, puis Semantic UI, puis index.css)

const middleware = [thunk];
const store = createStore(rootReducer, applyMiddleware(...middleware));
onUpdateAvailable(registration => store.dispatch(setUpdateAvailable(registration)));

// isOnline suit l'état réel de l'API ; branché ici car App est monté après l'évènement « load »
installConnectivity(Axios);
store.dispatch(setIsOnline(Connectivity.isOnline()));
Connectivity.subscribe(isOnline => {
    store.dispatch(setIsOnline(isOnline));
    // Le hub n'est démarré qu'une fois RealtimeUtil.init() appelé par App
    if (isOnline && RealtimeUtil.isInitialized) RealtimeUtil.retryNow();
});
RealtimeUtil.on('connected', () => Connectivity.reportSuccess());
RealtimeUtil.on('reconnecting', () => Connectivity.probe());

ReactDOM.createRoot(document.getElementById("root")).render(
    <Provider store={store}>
        <ErrorBoundary isGlobal={true}>
            <App />
        </ErrorBoundary>
    </Provider>
);
